<script setup lang="ts">
defineOptions({
	name: "Home",
});
definePage({
	name: "base",
	redirect: "/auth",
});
</script>

<template>
	<div id="home-page">
		<header-bar></header-bar>
	</div>
</template>

<style lang="scss" scoped>
#home-page {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	user-select: none;
	.page {
		flex-grow: 1;
	}
	.banner-section {
		flex: 1;
	}
}
</style>
